import { render, staticRenderFns } from "./contact-info-view-tab.vue?vue&type=template&id=a0c70570&scoped=true"
import script from "./contact-info-view-tab.vue?vue&type=script&lang=js"
export * from "./contact-info-view-tab.vue?vue&type=script&lang=js"
import style0 from "./contact-info-view-tab.vue?vue&type=style&index=0&id=a0c70570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c70570",
  null
  
)

export default component.exports